
import DownloadOverlayButton from './DownloadOverlayButton'

export default {
  name: 'OverlayGridItemInfo',
  components: { DownloadOverlayButton },
  props: {
    portrait: Boolean,
    mouseover: Boolean,
    artificialHover: Boolean,
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    styleCategories () {
      if (this.theme && this.theme.style_categories && this.theme.style_categories.length > 0) {
        return this.theme.style_categories.map(s => s.name).slice(0, 3).join(' • ')
      }

      return null
    },

    eventCategory () {
      if (this.theme && this.theme.event_categories && this.theme.event_categories.length > 0) {
        return this.theme.event_categories[0].name
      }

      return null
    },

    liked () {
      return this.$store.getters['like/getLiked'](this.theme.id)
    }
  },
  methods: {
    download () {
      this.$store.dispatch('consume/consumeEntitlement', {
        id: this.theme.id,
        type: 'themes',
        confirmed: true
      })
    },

    like (like) {
      this.$store.dispatch('like/likeTheme', {
        themeId: this.theme.id,
        liked: like
      })
    }
  }
}
